// Get each modal and close button
const triggers = document.getElementsByClassName("info-btn-trigger");
const triggerInfoArray = Array.from(triggers).entries();
const modals = document.getElementsByClassName("modal");
const closeButtons = document.getElementsByClassName("close-button");

// Use foreach loop with the an index on each item in `triggerInfoArray` 
// which listens to click event to toggles each modal to open and close
for (let [index, trigger] of triggerInfoArray) {
  const toggleModal = function() {
    modals[index].classList.toggle("show-modal");
  };

  trigger.addEventListener("click", toggleModal);
  closeButtons[index].addEventListener("click", toggleModal);
}
